import {Observable, Subscription} from 'rxjs';

import IFrameStore from '../Interfaces/IFrameStore';

const subscribeToConsumerToggleControls = (
    consumerToggleUi$: Observable<boolean>,
    frameStore: IFrameStore
): Subscription =>
    consumerToggleUi$
        .subscribe((shouldShow: boolean) => shouldShow ?
            frameStore.actions.activateControls() :
            frameStore.actions.idleControls()
        );

export default subscribeToConsumerToggleControls;